"use strict";

var cartStockAvailability = require("../cart/cartStockAvailability");
var isCheckoutStockBlocked = false;
var lastStockAvailabilityData = null;

function isShippingStageActive() {
    return $("#checkout-main").attr("data-checkout-stage") === "shipping";
}

function hasVisibleStockMismatchBanner() {
    if (isStorePickupSelected()) {
        return false;
    }

    var $stockError = $(".js-stock-error");
    if (!$stockError.length) {
        return false;
    }

    // Ignore banner when intentionally hidden for pickup.
    if ($stockError.hasClass("d-none")) {
        return false;
    }

    return $stockError.is(":visible") || $stockError.hasClass("show");
}

function updateShippingContinueButtonState() {
    var $nextButton = $(".next-step-button button");
    if (!$nextButton.length) {
        return;
    }

    var shouldBlockByBanner = hasVisibleStockMismatchBanner();
    var shouldDisableButton = isShippingStageActive() && (isCheckoutStockBlocked || shouldBlockByBanner);

    if (shouldDisableButton) {
        $nextButton.prop("disabled", true).addClass("stock-blocked");
    } else if ($nextButton.hasClass("stock-blocked")) {
        $nextButton.prop("disabled", false).removeClass("stock-blocked");
    }
}

function setCheckoutStockBlocked(shouldBlock, modalData) {
    isCheckoutStockBlocked = !!shouldBlock;
    if (modalData) {
        lastStockAvailabilityData = modalData;
    } else if (!isCheckoutStockBlocked) {
        lastStockAvailabilityData = null;
    }
    updateShippingContinueButtonState();
}

function clearPickupStockModalAndBlock() {
    setCheckoutStockBlocked(false);
    var $stockModal = $(".js-cart-stock-availability-modal");
    if ($stockModal.length && $stockModal.hasClass("show")) {
        $stockModal.modal("hide");
    }
}

function syncStockMismatchBannerVisibility() {
    var $stockErrorBanner = $(".js-stock-error");
    if (!$stockErrorBanner.length) {
        return;
    }

    // Keep top mismatch banner only for home delivery.
    $stockErrorBanner.toggleClass("d-none", isStorePickupSelected());
}

function togglePickupStoresVisibility(showStores) {
    var $pickupPane = $("#pickup-shipping");
    if (!$pickupPane.length) {
        return;
    }

    var $statusMessage = $pickupPane.find(".js-pickup-stock-status-message");
    if (!$statusMessage.length) {
        $statusMessage = $(
            "<div class=\"js-pickup-stock-status-message shipping-delivery-alert d-none mt-3\" role=\"alert\">"
                + "<div class=\"alert-icon\">"
                + "<svg class=\"alert-icon-svg\" xmlns=\"http://www.w3.org/2000/svg\" height=\"32px\" width=\"32px\" viewBox=\"0 -960 960 960\">"
                + "<path d=\"M480-360q17 0 28.5-11.5T520-400q0-17-11.5-28.5T480-440q-17 0-28.5 11.5T440-400q0 17 11.5 28.5T480-360Zm-40-160h80v-240h-80v240ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z\"/>"
                + "</svg>"
                + "</div>"
                + "<div class=\"alert-content\"><p class=\"alert-text\"></p></div>"
            + "</div>"
        );
        $pickupPane.prepend($statusMessage);
    }

    if (showStores) {
        $pickupPane.find(".shipping-method-card").removeClass("d-none");
        $pickupPane.find(".shipping-to-label").removeClass("d-none");
        $statusMessage.addClass("d-none").text("");
    } else {
        // Keep location header + "cambiar ubicación" visible; hide only stores list.
        $pickupPane.find(".shipping-method-card").addClass("d-none");
        $pickupPane.find(".shipping-to-label").addClass("d-none");
        $statusMessage
            .removeClass("d-none")
            .find(".alert-text")
            .text("No hay stock suficiente para retiro en farmacia con la ubicación actual.");
    }
}

function refreshStockAvailabilityOnCheckoutLoad() {
    var checkUrl = $(".shipping-section").data("check-store-availability-url");

    if (!checkUrl) {
        return;
    }

    $.ajax({
        url: checkUrl,
        type: "GET",
        dataType: "json"
    });
}

function checkStoreAvailability() {
    var $shippingSection = $(".shipping-section");
    var checkUrl = $shippingSection.data("check-store-availability-url");

    if (!checkUrl) {
        return;
    }

    // This validation/modal is only for pickup-in-store flow.
    if (!isStorePickupSelected()) {
        clearPickupStockModalAndBlock();
        togglePickupStoresVisibility(true);
        return;
    }

    $.ajax({
        url: checkUrl,
        type: "GET",
        dataType: "json",
        success: function (data) {
            // Só o servidor decide. Ler o DOM (".js-stock-error") abria o modal no Retiro com
            // estoque completo sempre que o alerta de despacho estava na página (ticket 995726).
            var shouldOpenModal = !!(data && (data.hasProductsWithoutStock || !data.hasStores || data.stockServiceError));

            setCheckoutStockBlocked(shouldOpenModal, data);
            togglePickupStoresVisibility(!shouldOpenModal);

            if (shouldOpenModal) {
                cartStockAvailability.showStockAvailabilityModal(data);
            }
        }
    });
}

function isStorePickupActive() {
    var $pickupTab = $("#pickup-shipping-tab");
    var $pickupPane = $("#pickup-shipping");
    return $pickupTab.hasClass("active") || $pickupPane.hasClass("show") || $pickupPane.hasClass("active");
}

function isStorePickupSelected() {
    // A aba ativa do Bootstrap é a fonte de verdade quando existe: o clique na aba nem sempre
    // dispara change nos rádios (visto no fluxo de convidado), e o rádio ficava dizendo
    // "retiro" com a aba de despacho aberta.
    var $pickupTab = $("#pickup-shipping-tab");
    var $deliveryTab = $("#delivery-shipping-tab");
    if ($pickupTab.hasClass("active") || $deliveryTab.hasClass("active")) {
        return $pickupTab.hasClass("active");
    }

    var selectedDeliveryType = $("input[name=\"deliveryType\"]:checked").val();
    var pickupDeliveryType = $("#storePickup").val();

    return !!(selectedDeliveryType && pickupDeliveryType && selectedDeliveryType === pickupDeliveryType);
}

function isShippingContinueBlocked() {
    return isShippingStageActive() && (isCheckoutStockBlocked || hasVisibleStockMismatchBanner());
}

function getCheckoutShippingUrl() {
    var checkoutShippingUrl = $("#checkout-main").data("checkout-shipping-url");
    if (checkoutShippingUrl) {
        return checkoutShippingUrl;
    }

    var href = window.location.href.split("?")[0];
    return href + "?stage=shipping";
}

/**
 * Home delivery has no server-rendered banner when the stock service failed; show the generic
 * message next to the shipping form so the blocked button is explained.
 */
function showHomeDeliveryStockMessage() {
    var message = $(".shipping-section").data("stock-service-error-message");
    var $container = $(".shipping-error");

    if (!message || !$container.length || $container.find(".js-stock-service-error").length) {
        return;
    }

    $container.append(
        $("<div>", { "class": "alert alert-danger js-stock-service-error", role: "alert" }).text(message)
    );
}

/**
 * Handles checkout stock-error AJAX responses without redirecting to the cart.
 * Pickup (retiro): opens the commune-change stock modal via CheckStoreAvailability.
 * Home delivery: blocks continue and surfaces the stock banner when present.
 * Other stages: reloads checkout at the shipping step.
 * @param {string} [source] - Debug source label for logging
 * @param {Object} [data] - Optional AJAX payload (may include isPickup)
 * @returns {boolean} Always true
 */
function handleCheckoutStockErrorResponse(source, data) {
    var currentStage = $("#checkout-main").attr("data-checkout-stage");
    var isPickupContext = (data && data.isPickup) || isStorePickupSelected();

    if (currentStage === "shipping" && isPickupContext) {
        togglePickupStoresVisibility(false);
        checkStoreAvailability(source || "checkout-stock-error");
        return true;
    }

    if (currentStage === "shipping") {
        setCheckoutStockBlocked(true);
        syncStockMismatchBannerVisibility();
        var $banner = $(".js-stock-error");
        if ($banner.length) {
            $banner.removeClass("d-none").addClass("show");
        } else {
            showHomeDeliveryStockMessage();
        }
        updateShippingContinueButtonState();
        return true;
    }

    window.location.href = getCheckoutShippingUrl();
    return true;
}

/**
 * Redirects to cart/other URL unless the response is a checkout stock error.
 * @param {Object} data - AJAX response payload
 * @param {string} [source] - Debug source label
 * @returns {boolean} True when a stock error was handled
 */
function handleStockOrRedirect(data, source) {
    if (data && data.stockError) {
        handleCheckoutStockErrorResponse(source || "ajax-stock-error", data);
        return true;
    }

    if (data && data.redirectUrl) {
        window.location.href = data.redirectUrl;
        return true;
    }

    return false;
}

/**
 * Runs the shipping-stage evaluation. Guests reach this stage only after "Comprar como
 * invitado"; running it at page load (stage "customer") left the button state stale.
 * @param {string} source - debug label
 */
function onShippingStageEntered(source) {
    updateShippingContinueButtonState();
    syncStockMismatchBannerVisibility();

    if (isStorePickupSelected()) {
        checkStoreAvailability(source);
    } else {
        clearPickupStockModalAndBlock();
        togglePickupStoresVisibility(true);
        refreshStockAvailabilityOnCheckoutLoad();
    }
}

function observeCheckoutStage() {
    var main = document.getElementById("checkout-main");
    if (!main || typeof MutationObserver === "undefined") {
        return;
    }

    var observer = new MutationObserver(function () {
        if (isShippingStageActive()) {
            onShippingStageEntered("stage-shipping");
        } else {
            updateShippingContinueButtonState();
        }
    });
    observer.observe(main, { attributes: true, attributeFilter: ["data-checkout-stage"] });
}

function init() {
    if (!$(".shipping-section").length) {
        return;
    }

    cartStockAvailability.init();
    updateShippingContinueButtonState();
    syncStockMismatchBannerVisibility();

    $("body").on("click", ".next-step-button button", function (e) {
        if ((isCheckoutStockBlocked || hasVisibleStockMismatchBanner()) && isShippingStageActive()) {
            e.preventDefault();
            e.stopImmediatePropagation();

            if (lastStockAvailabilityData) {
                cartStockAvailability.showStockAvailabilityModal(lastStockAvailabilityData);
            }
        }
    });

    $("body").on("checkout:updateCheckoutView", function () {
        updateShippingContinueButtonState();
        syncStockMismatchBannerVisibility();
    });

    observeCheckoutStage();

    setTimeout(function () {
        if (isShippingStageActive()) {
            onShippingStageEntered("page-load");
        }
        // Na etapa "customer" (convidado) o observador acima roda a avaliação quando a etapa
        // virar "shipping"; abrir o modal antes disso cobria a tela de "Comprar como invitado".
    }, 700);

    $("body").on("shown.bs.tab", "#delivery-shipping-tab", function () {
        syncStockMismatchBannerVisibility();
        updateShippingContinueButtonState();
    });

    $("body").on("click", "#pickup-shipping-tab", function () {
        setTimeout(function () {
            if (isStorePickupActive()) {
                checkStoreAvailability("pickup-tab-click");
            }
        }, 500);
    });

    $("body").on("shown.bs.tab", "#pickup-shipping-tab", function () {
        setTimeout(function () {
            checkStoreAvailability("pickup-tab-shown");
        }, 500);
    });

    $("body").on("change", "input[name=\"deliveryType\"]", function () {
        setTimeout(function () {
            if (isStorePickupSelected()) {
                checkStoreAvailability("delivery-type-change");
            } else {
                clearPickupStockModalAndBlock();
                togglePickupStoresVisibility(true);
            }
            syncStockMismatchBannerVisibility();
        }, 400);
    });

    $("body").on("change", ".pickup-method-list input[type='radio']", function () {
        setTimeout(function () {
            if (isStorePickupSelected()) {
                checkStoreAvailability("pickup-pharmacy-change");
            }
        }, 300);
    });

    $("body").on("zone:changed", function () {
        if (isStorePickupSelected()) {
            checkStoreAvailability("pickup-zone-change");
        }
    });
}

module.exports = {
    init: init,
    checkStoreAvailability: checkStoreAvailability,
    handleCheckoutStockErrorResponse: handleCheckoutStockErrorResponse,
    handleStockOrRedirect: handleStockOrRedirect,
    isShippingContinueBlocked: isShippingContinueBlocked,
    updateShippingContinueButtonState: updateShippingContinueButtonState,
    isCheckoutStockBlocked: function () {
        return isCheckoutStockBlocked;
    }
};
